import { render, staticRenderFns } from "./addRemarkall.vue?vue&type=template&id=1866248e"
import script from "./addRemarkall.vue?vue&type=script&lang=js"
export * from "./addRemarkall.vue?vue&type=script&lang=js"
import style0 from "./addRemarkall.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports